export default class AxSelect {

    // DONE handle setting values of hidden default select
    // TODO close on click - only for regular
    // DONE TODO highlight selected labels in list
    // DONE TODO placeholder
    // TODO disabled states
        // Whole select
        // Option

    // TODO click outside to close
    // TODO take id, any inline styles or classes and add to details element
    // TODO optgroups
    // TODO destroy()
    // TODO work out why init using className thing is weird


    public static init(item: HTMLSelectElement) {
        if (!item) return;
        if ((item as any).isInitialised == true) return;

        AxSelect.buildSelect(item);
        (item as any).isInitialised = true;
    }

    public static buildSelect(origSelect: HTMLSelectElement) {
        // Get options
        let origOptions = origSelect.options;
        const isMultiSelect = origSelect.multiple;

        // Set unique hash
        let uuid = this.makeid(5);

        // Hide default control
        origSelect.hidden = true;

        // Build dropdown
        const docFrag = document.createDocumentFragment();

        // Create fancy select container
        const fancySelect = document.createElement('details');
        fancySelect.setAttribute('id', `ax-${origSelect.getAttribute('id')}` || `select-${uuid}`);
        // Add new classes and any classes from orig select
        fancySelect.classList.add(...origSelect?.classList);
        fancySelect.classList.add('ax-select');
        if (isMultiSelect) fancySelect.classList.add('ax-select--multi');

        docFrag.appendChild(fancySelect);

        // Create dummy select and dropdown containers
        const fancySelectInput = document.createElement('summary');
        fancySelectInput.setAttribute('placeholder', origSelect.getAttribute('placeholder') || '');
        const fancySelectDropdown = document.createElement('ul');

        docFrag?.querySelector('details')?.appendChild(fancySelectInput);
        docFrag?.querySelector('details')?.appendChild(fancySelectDropdown);

        // Add options
        Array.from(origOptions).forEach((option: HTMLOptionElement) => {

            let optionControl = document.createElement('input');
            // If multiple use checkboxes, otherwise radios
            isMultiSelect ? optionControl.setAttribute('type', 'checkbox') : optionControl.setAttribute('type', 'radio');
            optionControl.setAttribute('name', `select-${uuid}`); // groups them together
            optionControl.setAttribute('id', `${option.text}-${uuid}`);
            optionControl.setAttribute('title', option.text);
            optionControl.setAttribute('value', option.value);
            optionControl.checked = option.selected;

            let optionLabel = document.createElement('label');
            optionLabel.innerHTML = option.text;
            optionLabel.setAttribute('for',  `${option.text}-${uuid}`);

            fancySelectInput.appendChild(optionControl);
            fancySelectDropdown.appendChild(optionLabel);

            optionControl.addEventListener('change', () => {
                if (!isMultiSelect) {
                    // If single select, remove selected class from other labels
                    optionLabel?.parentNode?.querySelectorAll('selected').forEach((item) => {
                        item.classList.remove('selected');
                    })
                    // Close dropdown on click if single select
                    optionControl.closest('details')?.removeAttribute('open');
                }

                // Toggle the checkbox display in dropdown
                optionLabel.classList.toggle('selected');

                // Set the value of the hidden default select element
                const optionSelector = !!optionControl.value
                    ? `[value="${optionControl.value}"]`
                    : ':not([value])';
                origSelect.querySelectorAll(optionSelector).forEach((option) => {
                    (option as HTMLOptionElement).selected = !(option as HTMLOptionElement).selected;
                })
            });

        });

        origSelect?.parentNode?.insertBefore(docFrag, origSelect.nextSibling);

        // Watch and toggle the placeholder text if items checked
        let intersectionObserver = new IntersectionObserver(function(entries) {
            let triggerEl = entries[0];

            if (AxSelect.anyOptionChecked(triggerEl?.target?.parentNode)) {
                (triggerEl?.target?.parentNode as HTMLElement)?.setAttribute('placeholder', '')
            } else {
                (triggerEl?.target?.parentNode as HTMLElement)?.setAttribute('placeholder', origSelect.getAttribute('placeholder') || '')
            }
        });

        // start observing each input in <summary>
        fancySelectInput?.querySelectorAll('input').forEach((item) => {
            intersectionObserver.observe(item);
        })

        // Watch origSelect and update details with changes
        const config = { attributes: true, childList: true, subtree: false };

        const observer = new MutationObserver(function(mutationsList, observer) {
            for (const mutation of mutationsList) {
                if (mutation.type === 'attributes') {
                    const attribute = mutation.attributeName || '';

                    if (origSelect.getAttribute(attribute)) {
                        fancySelect.setAttribute(attribute, origSelect.getAttribute(attribute) || '')
                    } else {
                        fancySelect.removeAttribute(attribute)
                    }
                }
            }
        });

        // Start observing the target node for configured mutations
        observer.observe(origSelect, config);
    }

    public static destroy(item: HTMLElement) {
        // Can destroy using either orig select or new details element
        if (item?.nodeName == 'SELECT') {
            (item as HTMLElement).hidden = false;
            (item as any).isInitialised = false;
            if (item.nextSibling) {
                item.nextSibling.remove();
            }
        } else if (item?.nodeName == 'DETAILS') {
            if (item.previousSibling) {
                (item.previousSibling as HTMLElement).hidden = false;
                (item.previousSibling as any).isInitialised = false;
            }
            item.remove();
        }
    }

    public static destroyAll() {
        let fancySelects = document.querySelectorAll('details.ax-select');
        fancySelects.forEach((fancySelect) => {
            if (fancySelect.previousSibling) {
                (fancySelect.previousSibling as HTMLElement).hidden = false;
                (fancySelect.previousSibling as any).isInitialised = false;
            }
            fancySelect.remove();
        });
    }

    public static getSelectValues(select: HTMLSelectElement) {
        var result = [];
        var options = select && (select as any).options;
        var opt;

        for (var i=0, iLen=options.length; i<iLen; i++) {
          opt = options[i];

          if (opt.selected) {
            result.push(opt.value || opt.text);
          }
        }
        return result;
    }

    // UTILITY FUNCTIONS
    private static anyOptionChecked(parent: any) {
        var inputElements = parent?.getElementsByTagName("input");
        if (!inputElements) return false;
        for (var i = 0; i < inputElements.length; i++)
            if (inputElements[i].checked)
                return true;
        return false;
    }

    private static makeid(length: number) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() *
            charactersLength));
        }
       return result;
    }
};
